import React from "react";
import camelCase from "lodash/camelCase";
import upperFirst from "lodash/upperFirst";
import IndexPage from "../pages";
import ComponentPage from "../pages";
import ExamplePage from "../examples/index";

import { classes as docsClasses } from "../common/docs.st.css";
/**
 * Here we define the application's routes. Any route prefixes should not be
 * included here.
 */

const routes = [
  {
    path: "",
    action: () => <IndexPage className={docsClasses.root} path="docs" />
  },
  {
    path: "/components",
    action: () => (
      <ComponentPage className={docsClasses.root} path="components" />
    )
  },
  {
    path: "/examples",
    // Where we display the example pages put together
    action: () => (
      <ComponentPage className={docsClasses.root} path="docs/examples" />
    )
  },
  {
    path: "/examples/:pageName",
    // Example pages
    action: (context: any) => {
      // ../../docs/examples/pages/OurTeam
      const pageName = upperFirst(camelCase(context.params.pageName));
      return <ExamplePage path={`examples/pages/${pageName}`} />;
    }
  },
  {
    path: "/components/:componentName",
    action: (context: any) => {
      // Changes componentName from URL into PascalCase
      // ex: footer -> Footer, header-menu-item -> HeaderMenuItem
      const componentName = upperFirst(camelCase(context.params.componentName));
      return (
        <ComponentPage
          className={docsClasses.root}
          path={`components/${componentName}`}
        />
      );
    }
  }
];

export default routes;
